import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Auth, AuthProvider, useAuth } from "./auth/AuthContext";
import { DocumentTitle } from "./DocumentTitle";
import { InstanceProvider } from "./instance/InstanceContext";
import { InstanceList } from "./instance/InstanceList";
import { LicenceOptionsProvider } from "./licence/LicenceOptions";
import { LicencePage } from "./licence/LicencePage";
import { ReportPage } from "./report/ReportPage";
import { ReportProvider } from "./report/ReportContext";
import PageHeader from "./PageHeader";

export const App = (): JSX.Element => {
   return (
      <DocumentTitle title="Licence Server">
         <HashRouter>
            <AuthProvider>
               <PageHeader />
               <br />
               <br />
               <LicenceOptionsProvider>
                  <InstanceProvider>
                     <Routes>
                        <Route path="/instances" element={<InstanceList />} />
                        <Route path="/licences/*" element={<LicencePage />} />
                        <Route
                           path="/report/*"
                           element={
                              <ReportProvider>
                                 <ReportPage />
                              </ReportProvider>
                           }
                        />
                        <Route path="/*" element={<RedirectRoute />} />
                     </Routes>
                  </InstanceProvider>
               </LicenceOptionsProvider>
            </AuthProvider>
         </HashRouter>
      </DocumentTitle>
   );
};

const RedirectRoute = (): JSX.Element => {
   const auth: Auth = useAuth();
   if (auth?.user?.permissions?.instance?.canView) {
      window.location.replace("#/instances");
   } else if (auth?.user?.permissions?.licence?.canView) {
      window.location.replace("#/licences");
   } else {
      return <div>You do not have permission to be here.</div>;
   }
   return <></>;
};
